"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.render = exports.setOpen = exports.completeStep = exports.setText = exports.get = void 0;
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageUiCanvas_sidecar_1 = require("@voyage/ui/voyageUiCanvas-sidecar");
var voyageUiGraphicsUtils_sidecar_1 = require("@voyage/ui/voyageUiGraphicsUtils-sidecar");
var voyageGameMode_tutorial_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_tutorial-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyagePicker_sidecar_1 = require("@voyage/ui-cursors/voyagePicker-sidecar");
var voyageSounds_sidecar_1 = require("@voyage/sounds/voyageSounds-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
        exports.setOpen(false);
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var tw = 0;
    var th = 0;
    var canvas = voyageUiCanvas_sidecar_1.voyageUiCanvas.create(tw, th, voyageLayers_sidecar_1.voyageLayers.getLayers().uiGame);
    canvas.autoOffset = false;
    var obj = voyageUiCanvas_sidecar_1.voyageUiCanvas.assign(canvas, {
        //slot: 1,
        //hoveredPart: null,
        header: 'Tutorial',
        text: 'Tutorial Text',
    });
    return obj;
};
var setText = function (h, t) {
    var obj = get();
    obj.header = h;
    obj.text = t;
};
exports.setText = setText;
var completeStep = function () {
    if (voyageGameMode_tutorial_sidecar_1.voyageGameMode_tutorial.getIsSkipped()) {
        return 0;
    }
    var obj = get();
    obj.text += '\n\nGreat!';
    voyageSounds_sidecar_1.voyageSounds.playSuccess();
    return 1;
};
exports.completeStep = completeStep;
var setOpen = function (isOpen) {
    var obj = get();
    voyageUiCanvas_sidecar_1.voyageUiCanvas.setOpen(obj, isOpen);
};
exports.setOpen = setOpen;
var render = function () {
    var obj = get();
    var g = obj.graphics;
    voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    var x = 500;
    var y = 100;
    var addText = function (text, ox, oy) {
        if (ox === void 0) { ox = 0; }
        if (oy === void 0) { oy = 0; }
        var t = voyageUiCanvas_sidecar_1.voyageUiCanvas.addText(obj, text, x + ox, y + oy, 3);
        y += 20;
        return t;
    };
    // let w = gb.width - 150 * 2
    // let h = 200
    // x = 150
    // y = gb.height - h - 20
    var w = 550;
    var h = 250;
    // goatGraphicsUtils.bevelPanelBackground(g, x, y, w, h)
    var vp = voyagePicker_sidecar_1.voyagePicker.get();
    var cr = vp.hoveredCrew || vp.selectedCrew;
    // let sys = vp.hoveredSystem
    voyageUiGraphicsUtils_sidecar_1.voyageUiGraphicsUtils.bevelPanel2(g, x, y, w, h);
    x += 20;
    y += 20;
    addText(obj.header, 6, 0);
    y += 20;
    x += 30;
    addText(obj.text);
    y += 150;
    if (!voyageGameMode_tutorial_sidecar_1.voyageGameMode_tutorial.getIsSkipped()) {
        addText('To skip tutorial, press X');
    }
    voyageUiCanvas_sidecar_1.voyageUiCanvas.render(obj);
};
exports.render = render;
var update = function () {
    var obj = get();
    if (obj.isOpen) {
        voyageUiCanvas_sidecar_1.voyageUiCanvas.update(obj);
        exports.render();
    }
    else {
        voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    }
};
exports.update = update;
